import React from 'react'

import image from '../../Assets/LiveClass.png'
import Navbar from '../../Components/Navbar/Navbar';
import Hero from '../../Components/Hero/Hero';
import Footer from '../../Components/Footer/Footer';

import { StudentNavItems } from './StudentNavItems';
import { STUDENT_USER_TYPE } from '../../services/UserService';

import BatchView from '../../Components/Batches/BatchView';
import SlotView from '../../Components/Slots/SlotView';
import { useParams } from 'react-router-dom';

const StudentSlots = () => {
    const { slotId } = useParams();
    return (
        <div className="flex flex-col min-h-screen">
            <Navbar navItems={StudentNavItems} user={STUDENT_USER_TYPE} />
            <SlotView slotId={parseInt(slotId)} user={STUDENT_USER_TYPE} />
            <Footer user={STUDENT_USER_TYPE} />
        </div>
    )
};

export default StudentSlots;